<template>
  <div class="ws-contact-container">
    <div class="ws-contact-label" v-if="label && whatsappLink">
      <a :href="whatsappLink" target="_blank">
        {{ label }}
      </a>
    </div>
    <div class="ws-icon" v-if="whatsappLink">
      <a :href="whatsappLink" target="_blank">
        <img src="../../assets/ws-icon-500x500.png" alt="whatsapp" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WhatsappContact',
  props: {
    phone: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      whatsappLink: `https://wa.me/${this.phone}`,
    };
  },
};
</script>
<style lang="scss">
.ws-contact-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  a, a:visited {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #fff;
  }
  .ws-contact-label {
    font-weight: 400;
    color: #fff;
    background-color: #35b34a;
    padding: 7px 20px 7px 10px;
    margin-right: -10px;
    border-radius: 10px 0 0 10px;
    border: 1px solid #fff;
  }
  .ws-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
